import { Controller } from '@hotwired/stimulus';
import * as L from 'leaflet';
import markerUrl from '../../images/icons/map-marker.svg';

export default class extends Controller {

    markers = [];

    connect() {
        const style = this.element.dataset.style;
        const zoom = this.element.dataset.zoom ?? 14;
        let center = this.element.dataset.center;
        let locations = this.element.dataset.locations;
        locations = locations ? JSON.parse(locations) : {};

        if (center) {
            center = center.split(',');
            center = [center[0], center[1]];
        }

        if (locations.length > 0) {
            this.element.removeAttribute('data-locations');
            center = [locations[0][0], locations[0][1]];
        }

        const map = L.map(this.element, {
            center: center,
            zoom: zoom,
            zoomSnap: false,
            scrollWheelZoom: false,
        });

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '',
            id: style === "dark" ? 'demovilius/cltse8nns002u01qschze14g2' : 'demovilius/clrojglf0006t01o37x1vflyu',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoiZGVtb3ZpbGl1cyIsImEiOiJjbHJvamI2aXYwOGliMm1uajAwYnltb3VsIn0.QmGEEfk28HoaBKytCvRw5g',
        }).addTo(map);

        if (locations.length > 0) {
            const markerIcon = L.icon({
                iconUrl: markerUrl,
                iconSize: [32, 32],
                iconAnchor: [16, 32],
                popupAnchor: [0, 0],
            });

            locations.forEach((info) => {
                const marker = new L.marker([info[0], info[1]], { icon: markerIcon }).addTo(map)
                this.markers.push(marker);
            });

            if (locations.length > 1) {
                // try to fit markers in map view
                const bounds = new L.featureGroup(this.markers).getBounds();
                map.fitBounds(bounds, { padding: [50, 100] });
            }
        }
    }
}